export default __webpack_public_path__ + "images/7a15e8e69aa6db028b78a1d2cd352180.svg";